module.exports = __webpack_public_path__ + "resources/privacy-35a868f953b6b1283219653fdfd195db.svg";